module.exports = __webpack_public_path__ + "img/storepaytext.25aae095.png";